var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"items":_vm.items,"headers":_vm.headers,"hide-default-footer":"","disable-pagination":"","item-key":"ontime"},scopedSlots:_vm._u([{key:"item.status",fn:function({ item }){return [_c('alert-status-template',{attrs:{"status":item.status}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }